module.exports = __webpack_public_path__ + "static/media/stage-3.50e187b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/DevelopingABrandCharacter/stage-3.jpg
// module id = 412
// module chunks = 0